import { render } from "./CategoryList.vue?vue&type=template&id=0fa7b31b&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=0fa7b31b&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa7b31b"]])

export default __exports__